import { Box, Typography } from '@mui/material';
import AdminLayout from '../../components/admin/AdminLayout';

const SecurityCompliancePage = () => {
  return (
    <AdminLayout>
      <Box sx={{ p: 3 }}>
        <Typography variant="h4" color="text.primary" gutterBottom>
          Security & Compliance
        </Typography>
        <Typography variant="body1" color="text.secondary">
          Security and compliance content will be implemented here.
        </Typography>
      </Box>
    </AdminLayout>
  );
};

export default SecurityCompliancePage; 